import { call, fork, takeLatest, select } from 'redux-saga/effects';

import { updateStatusNotification } from '../api';

import { notificationActions } from './actions';
import { getNotificationById } from './selectors';

export function* updateStatus({payload}) {
  const { notificationId } = payload;
  const notification = yield select(getNotificationById, notificationId);
  
  if ( !notification || !notification.dtLectura )
    yield call(updateStatusNotification, notificationId);
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchUpdateStatus() {
  yield takeLatest(notificationActions.LOAD_NOTIFICATION, updateStatus);
}

//=====================================
//  ROOT
//-------------------------------------

export const notificationSagas = [
  fork(watchUpdateStatus),
];
